/**
 *
 */

var Scroll = (function($) {
  function initIntroScroll() {
    $("html, body").animate(
      {
        scrollTop: $("#intro-scroll-target").offset().top - 20
      },
      1000
    );
  }

  function initIntroScrollMobile() {
    $("html, body").animate(
      {
        scrollTop: $("#intro-scroll-target").offset().top - 50
      },
      1000
    );
  }

  function initHomeServicesScroll() {
    $("html, body").animate(
      {
        scrollTop: $(".home-services-bottom").offset().top - 100
      },
      1000
    );
  }

  function init() {
    // return early if no corresponding module present
    if (!$("#intro-scroll-down").length) {
      return;
    }

    $("#intro-scroll-down").click(function() {
      initIntroScroll();
    });

    $("#intro-scroll-down-mobile").click(function() {
      initIntroScrollMobile();
    });

    $(".home-services-item__list-item").click(function() {
      initHomeServicesScroll();
    });
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Scroll.init);
